import { SxProps, Container } from '@mui/material';
import CenterStack from './center-stack';
import EmptyContent from '../empty-content';

type Props = {
  notFound: boolean;
  children: React.ReactNode;
  sx?: SxProps;
};

export default function NotFoundContainer({ notFound, children, sx }: Props) {
  if (notFound) {
    return (
      <CenterStack sx={{ height: '100%', ...sx }}>
        <EmptyContent
          filled
          title="ไม่พบข้อมูล"
          sx={{
            py: 10,
            ...sx,
          }}
        />
      </CenterStack>
    );
  }

  return <Container>{children}</Container>;
}
